module.exports = __webpack_public_path__ + "img/bory_nove_bloky_mapa.4bf4784d.png";